import { gql } from "@apollo/client";

export const GET_MY_ASSETS = gql`
  query getMyAssets {
    getMyAssets {
      assetId
      serialNumber
      name
      hostname
      platform
      osName
      osVersion
      model
      diskEncryption
      firewallEnabled
      mdmEnabled
      agentInstalled
      agentVersion
      edrInstalled
      edrStatus
      patchStatus
      enrollmentStatus
      ownerEmployeeId
      # Always the signed-in employee on this query — it filters by their own
      # employee_data.id — but surfaced so the details dialog can name them
      # instead of falling back to "Unassigned".
      ownerEmail
      ownerName
      lastActivityAt
      source
      integratedAccountId
      integrationName
      status
      currentStatus
      inactivityReason
      deviceType
      description
      disposableDate
      # Out-of-scope devices stay in this list, flagged rather than hidden.
      inScope
      scopeReason
      checkStatus {
        assetId
        totalChecksCount
        passedChecksCount
        failedChecksCount
        disabledChecksCount
        checks {
          activeCheckId
          checkType
          status
          statusReason
          createdAt
          updatedAt
        }
      }
    }
  }
`;
